/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    object, string,
} from 'prop-types';

// strips "font-family:" and ";" from value
const parseFont = (font) => font?.match(/:\s(.*?);/, '')?.[1] || null;

const useStyles = makeStyles((theme) => ({
    countDownText: (styling) => ({
        display: 'flex',
        color: styling.colors.countdown?.color || theme.palette.white || '#ffffff',
        fontFamily: parseFont(styling.fonts.timer) || 'inherit',
        fontSize: '22px',
        letterSpacing: '-1.5px',
        fontWeight: 'bold',
        width: '100%',
        '& span': {
            fontSize: '9px',
            color: styling.colors.countdown?.color || '#fff',
            display: 'block',
            letterSpacing: 'initial',
        },
        [theme.breakpoints.down(1030)]: {
            fontSize: '18px',
        },
    }),
    countDownTime: {
        display: 'block',
        padding: '0 2px',
        textAlign: 'center',
    },
    countDownTimeText: {
        fontSize: '12px',
        letterSpacing: '0.47px',
    },
}));
const OfferTimer = ({ dateCountDown, styling }) => {
    const classes = useStyles(styling);
    const countDownDate = new Date(dateCountDown).getTime();
    let nowTime = new Date().getTime();
    const [state, setState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const updateCountdown = () => {
        if (countDownDate) {
            nowTime = new Date().getTime();
            // Get the time remaining until the countdown date
            const distanceToDate = countDownDate - nowTime;
            // Calculate days, hours, minutes and seconds remaining
            let days = Math.floor(
                (distanceToDate / (1000 * 60 * 60 * 24)),
            );
            let hours = Math.floor(
                (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            );
            let minutes = Math.floor(
                (distanceToDate % (1000 * 60 * 60)) / (1000 * 60),
            );
            let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

            // For visual appeal, add a zero to each number that's only one digit
            const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];
            if (numbersToAddZeroTo.includes(days)) {
                days = `0${days}`;
            }
            if (numbersToAddZeroTo.includes(hours)) {
                hours = `0${hours}`;
            }
            if (numbersToAddZeroTo.includes(minutes)) {
                minutes = `0${minutes}`;
            }
            if (numbersToAddZeroTo.includes(seconds)) {
                seconds = `0${seconds}`;
            }
            // Set the state to each new time
            setState({
                days, hours, minutes, seconds,
            });
        }
    };

    useEffect(() => {
        setTimeout(() => updateCountdown(), 10);
    }, []);

    useEffect(() => {
        setInterval(() => updateCountdown(), 1000);
    }, []);

    return (
        <div>
            {nowTime < countDownDate
    && (
        <div className={classes.countDownText}>
            {state.days !== 0 && (
                <div className={classes.countDownTime}>
                    <div>{state?.days} : </div> <div className={classes.countDownTimeText}>days</div>
                </div>
            )}
            <div className={classes.countDownTime}>
                <div>{state?.hours || '00'} : </div><div className={classes.countDownTimeText}>hours</div>
            </div>
            <div className={classes.countDownTime}>
                <div>{state?.minutes || '00'} : </div><div className={classes.countDownTimeText}>mins</div>
            </div>
            <div className={classes.countDownTime}>
                <div>{state?.seconds || '00'}</div><div className={classes.countDownTimeText}>secs</div>
            </div>
        </div>
    )}
        </div>
    );
};
OfferTimer.propTypes = {
    styling: object.isRequired,
    dateCountDown: string.isRequired,
};
export default OfferTimer;
